import React from 'react'
import UiContentCard from "../../../components/cards/UiContentCard"
import London from "../../../../../styles/img/favourites/london.jpg"
import Nike from "../../../../../styles/img/favourites/nike.jpg"
import Tokyo from "../../../../../styles/img/favourites/tokyo.jpg"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import { useNavigate } from "react-router-dom";

export default function CurrentCampaigns(props) {
    let navigate = useNavigate(); 
    
    const readMore = () => {
        let path = `../../ui/incentives-spin-win-home`; 
        navigate(path);
    }

    return (
        <>
        
            <UiCol >
                <UiContentCard
                    cardImg={Nike}
                    heading="Nike"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    learnMore={readMore}
                    
                />
            </UiCol>
            <UiCol >
                <UiContentCard
                    cardImg={London}
                    heading="London"
                    learnMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    
                />
            </UiCol>
            <UiCol>
                <UiContentCard
                    cardImg={Tokyo}
                    heading="Tokyo"
                    learnMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    
                />
            </UiCol>
            <UiCol >
                <UiContentCard
                    cardImg={Nike}
                    heading="Nike"
                    learnMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    
                />
            </UiCol>
            <UiCol >
                <UiContentCard
                    cardImg={Nike}
                    heading="Nike"
                    learnMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                   
                />
            </UiCol>
            <UiCol >
                <UiContentCard
                    cardImg={Nike}
                    heading="Nike"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    learnMore={readMore}
                    
                />
            </UiCol>
            <UiCol >
                <UiContentCard
                    cardImg={London}
                    heading="London"
                    learnMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    
                />
            </UiCol>
            <UiCol>
                <UiContentCard
                    cardImg={Tokyo}
                    heading="Tokyo"
                    learnMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                   
                />
            </UiCol>
            <UiCol >
                <UiContentCard
                    cardImg={Nike}
                    heading="Nike"
                    learnMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    
                />
            </UiCol>
            <UiCol >
                <UiContentCard
                    cardImg={Nike}
                    heading="Nike"
                    learnMore={readMore}
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    
                />
            </UiCol>




        </>
    )
}
